import { CommonModule, JsonPipe } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { sectionHasQuestions } from '../../../../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormService } from '../../../../intake-form.service';
import { CIPXQuoteRequestIntakeForm } from '../../../../intake-form.types';
import { CIPXQuoteRequestIntakeFormQuestionSetComponent } from '../../../../question-set/question-set.component';
import { MaterialModule } from '@sbd-doug-frontend/app/shared/material.module';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    JsonPipe,
    SharedComponentsModule, CIPXQuoteRequestIntakeFormQuestionSetComponent],
  selector: 'cipx-quote-request-intake-form-request-details-screen-and-explain',
  templateUrl: 'screen-and-explain.component.html'
})

export class CIPXQuoteRequestIntakeFormRequestDetailsScreenAndExplainComponent implements OnInit {

  private _intakeService = inject(CIPXQuoteRequestIntakeFormService);
  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;

  selectedStateBond = this._intakeService.selectedStateBond;
  sectionHasQuestions = sectionHasQuestions

  constructor() { }

  ngOnInit() { }
}
